

































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Zygczb from "./details/zygczb.vue";
import Yanse from "./details/yanse.vue";
import Wenli from "./details/wenli.vue";
import Biaoqian from "./details/biaoqian.vue";
import Preview from "./preview/preview.vue";
import PicControl from "./details/picControl.vue";
@Component({
  components: {
    Zygczb,
    Yanse,
    Wenli,
    Biaoqian,
    Preview,
    PicControl,
  },
})
export default class IdrBiduiDetail extends Vue {
  private selectedTongues: any[] = [];
  private ifShowBiaozhu: boolean = false;
  private cPart: any = "中医观察指标";
  private cYingxiangPart: any = "";
  private ifShowPreview: boolean = false;
  /**
   * @description 返回列表页
   */
  private backList() {
    this.$router.push({
      path: "/main/idr/tongue-list",
    });
  }
  /**
   * @description 重新选择
   */
  private reChoose() {
    this.$router.push("/main/idr/tongue-bidui-list");
  }
  /**
   * @description part变化
   */
  private partChange(part) {
    this.cYingxiangPart = "";
    this.cPart = part;
  }
  /**
   * @description 影像组学参数变化
   */
  private yingxiangPartChange(ev) {
    this.cPart = "";
    this.cYingxiangPart = ev;
  }
  /**
   * @description 打开预览
   */
  private openPreview() {
    this.ifShowPreview = true;
  }
  /**
   * @description 关闭预览
   */
  private closePreview() {
    this.ifShowPreview = false;
  }
  /**
   * @description 初始化
   */
  private beforeMount() {
    const selectedTongues = localStorage.getItem("selectedTongues");
    if (selectedTongues) {
      this.selectedTongues = JSON.parse(selectedTongues);
    }
    if (this.selectedTongues.length <= 1) {
      this.$message.error("选择的舌图有误，请重新选择");
      return;
    }
  }
  // private beforeRouteEnter(to, from, next) {
  //   from.meta.keepAlive = false;
  //   next();
  // }
  // private beforeRouteLeave(to, from, next) {
  //   to.meta.keepAlive = true;
  //   next();
  // }
}
